// extracted by mini-css-extract-plugin
export default {"track":"fakeScrollbar__track__Mnjci","grabbed":"fakeScrollbar__grabbed__yQ6H_","thumb":"fakeScrollbar__thumb__WlGVA","hidden":"fakeScrollbar__hidden__XXBHJ"};